import { default as axios } from "axios";

export class GccsDeviceList {
    path = "http://192.168.1.34:9000/gccs/device_list"
    get() {
        return axios.get(this.path)
    }
}